export const quotaModalConfig = {
    content: {
        padding: "0 20px",
        width: "min(100% - 11px, 936px)",
        height: "auto",
        boxShadow: "rgba(27, 38, 83, 0.2) 0px 15px 12px, rgba(27, 38, 83, 0.2) 0px 19px 38px",
        backgroundColor: "#F5F9FD",
    },
    overlay: {
        background: "rgba(42, 62, 82, 0.8)",
    },
};
